<!--
 * @Author: your name
 * @Date: 2021-11-11 12:50:34
 * @LastEditTime: 2022-05-23 23:50:54
 * @LastEditors: liuwujiang@easyretailpro.com liuwujiang@easyretailpro.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\views\home.vue
-->
<template>
    <div class="container">
        <div class="page">
            <div class="title">欢迎进入百事RCD2.0平台</div>
            <div class="desc">请输入个人信息，登录专属账号</div>
            <div class="form">
                <div class="form-item">
                    <div class="form-item__label">手机号</div>
                    <div style="position: relative;">
                        <input class="form-item__input input-outline" v-model="form.phone" placeholder="请输入手机号码"  @input="onChange($event, 'phone')"/>
                        <span class="span-outline bottom-outline"></span>
                        <span class="span-outline right-outline"></span>
                        <span class="span-outline top-outline"></span>
                        <span class="span-outline left-outline"></span>
                    </div>
                    <div class="form-item__error" v-if="errors['phone']">{{errors['phone']}}</div>
                </div>
                <div class="form-item">
                    <div class="form-item__label">验证码</div>
                    <div class="form-item__input-right">
                        <div class="right__txt" v-if="!isSend" @click="getCodeByPhone()">{{sendMsg}}</div>
                        <div class=right__txt v-else>{{sendMsg}}</div>
                    </div>
                    <div style="position: relative;">
                        <input class="form-item__input input-outline" v-model="form.captcha" placeholder="请输入短信验证码" @input="onChange($event, 'captcha')"/>
                        <span class="span-outline bottom-outline"></span>
                        <span class="span-outline right-outline"></span>
                        <span class="span-outline top-outline"></span>
                        <span class="span-outline left-outline"></span>
                    </div>
                    <div class="form-item__error" v-if="errors['captcha']">{{errors['captcha']}}</div>
                </div>
                <div class="form-item">
                    <div class="form-item__label">图形验证码</div>
                    <div class="form-item__input-right">
                        <validate-code ref="ref_validateCode" class="right__img" @change="serCaptcha"></validate-code>
                        <!-- <img class="right__img" src="@/assets/images/sucai/code.png" /> -->
                    </div>
                    <div style="position: relative;">
                        <input class="form-item__input input-outline" v-model="form.code" placeholder="请输入图形验证码" @input="onChange($event, 'code')"/>
                        <span class="span-outline bottom-outline"></span>
                        <span class="span-outline right-outline"></span>
                        <span class="span-outline top-outline"></span>
                        <span class="span-outline left-outline"></span>
                    </div>
                    <div class="form-item__error" v-if="errors['code']">{{errors['code']}}</div>
                </div>
                <div class="form-item" style="margin-bottom: 0px;">
                    <button class="form-item__btn" @click="login()">
                        <div class="flex-mode" style="justify-content: center;">
                            <!-- <img style="width: 20px;height: 16px;margin-right: 4px;" src="@/assets/images/icons/wechat-icon.png"/> -->
                            登录
                        </div>
                    </button>
                </div>
            </div>
        </div>
        <div>
            <img class="prod" src="@/assets/images/sucai/prod.png" />
        </div>
        <mini-dialog v-model="show" height="313px" @confirm="confirm" @close="close"></mini-dialog>
        <mini-dialog v-model="showError" height="313px" @confirm="confirm" @close="close">
            <template #title>验证失败</template>
            <template #desc>当前微信与系统绑定手机号不一致</template>
        </mini-dialog>
    </div>
</template>
<script>
import ValidateCode from "@/components-busi/validate-code/index.vue";
import MiniDialog from '@/components-busi/mini-dialog/index.vue'
import { formMixins } from '@/mixins/form'
export default {
    mixins: [ formMixins ],
    data() {
        return {
            form: {
                phone: "",
                captcha: "",
                code: "",
                openId: "",
            },
            errors: {
                phone: '',
                captcha: '',
                code: '',
            },
            rules: [
                { name: "phone", validate: [{ require: true, message: '请输入11位有效的手机号'}, { regExp: /^[1][3,4,5,6,7,8,9][0-9]{9}$/ , message: '手机号格式不正确'}]},
                { name: "captcha", validate: [{ require: true, message: '请输入短信验证码'}]},
                { name: "code", validate: [{ require: true, message: '请输入图形验证码'}]},
            ],
            show: false,
            code: '', // 图形码，
            isSend: false,
            sendMsg: '获取验证码',
            authCode: '', // 微信授权code
            openId: '', // 用户在公众号中的唯一id
            showError: false,
        }
    },
    created() {
        this.openId = this.$route.query.openId
        // if(!this.openId) this.$router.replace('/login-auth')
        this.$store.dispatch('Clear')
        this.$utils.Watermark.clear()
    },
    computed: {
        compareCaptcha() {
            return function (code) {
                let answer = this.code
                if (code.toUpperCase() == answer) return true
                console.log(answer) 
                console.log(code.toUpperCase())
                this.errors['code'] = '验证码不正确'
                return false
            }
        },
        userInfo: {
            get () { return this.$store.state.userInfo },
            set (val) { this.$store.commit('user/SET_USER_INFO', val) }
        }
    },
    components: {
        MiniDialog,
        ValidateCode,
    },
    methods: {
        // 截取code
        GetParam(url, code) {
            url = url + "";
            let regstr = "/(\\?|\\&)" + code + "=([^\\&]+)/";
            let reg = eval(regstr);
            //eval可以将 regstr字符串转换为 正则表达式
            let result = url.match(reg);
            if (result && result[2]) {
                return result[2];
            }
        },
        /**
         * 设置验证码
         */
        serCaptcha(value) {
            console.log(value)
            this.code = value;
        },
        getCodeByPhone() {
            let formData = this.form
            if(!this.$utils.RegExp.isMobile(formData.phone)) {
                this.errors['phone'] = "请输入11位有效的手机号"
                return
            }
            let data = { phone: formData.phone, captcha: '' }
            this.$api.loginClient.sms(data).then(res=> {
                if(res) {
                    this.sendResult()
                    //this.$set(this.form, 'captcha', res.captcha)
                }
                else{
                    this.show = true
                }
            })
        },
        sendResult() {
            this.isSend = true;
            let timer = 60;
            this.sendMsg = timer + "s重发";
            this.timeFun = setInterval(() => {
                --timer;
                this.sendMsg = timer + "s重发";
                if (timer == 0) {
                    this.isSend = false;
                    this.sendMsg = "重新获取";
                    clearInterval(this.timeFun);
                }
            }, 1000);
        },
        async login() {
            let formData = this.form
            formData.openId = this.openId
            if(!this.validateForm(formData)) return;
            if(!this.compareCaptcha(formData.code)) return 
            const res = await this.$api.loginClient.phoneLogin(formData)
            if(res) {
                const data = res
                if(data.isLogin) {
                    this.loginSuccess(data.token)
                }
                else {
                    this.showError = true
                }
            }
        },
        loginSuccess(token) {
            var storage = this.$storage
            storage.set('token', token)
            // this.$store.dispatch('InitData')
            // this.$store.dispatch('getUserInfo')
            this.bindUser()
            this.nextPage()
        },
        async bindUser() {
            if(!this.openId) return
            let params = { openId: this.openId, phone: this.form.phone }
            await this.$api.loginClient.updateOpenId(params)
        },
        nextPage() {
            let newPath = this.$router.currentRoute.query.redirect
            this.$router.replace({path: newPath || '/'});
        },
        toRegisterPage() {
            this.$router.replace({
                name :'/register'
            })
        },
        showLoginFailDialog() {
            this.show = true
        },
        hideLoginFailDialog() {
            this.show = false
            this.showError = false
        },
        confirm() {
            this.hideLoginFailDialog()
        },
        close() {
            this.hideLoginFailDialog()
        }
    }
}
</script>
<style lang="less" scoped>
    @import './index.less';
</style>